import { registerPlugin } from "@capacitor/core";

export interface OrientationLockPlugin {
  lockPortrait(): Promise<void>;
  unlockOrientation(): Promise<void>;
}

export const OrientationLock = registerPlugin<OrientationLockPlugin>(
  "OrientationLock",
);
